import { useState } from 'react';
import { faqItems } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(faqItems[0]?.id ?? null);

  const toggle = (id: number) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="常见问题"
              title="关于本站你想知道的"
              desc="如果你在找片过程中遇到疑问，可以先看看下面这些说明。"
            />
            <div className="mt-8 p-5 rounded-lg bg-secondary-50 border border-secondary-200">
              <div className="flex items-start gap-3">
                <span className="w-10 h-10 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center shrink-0">
                  <i className="ri-information-line text-xl"></i>
                </span>
                <div>
                  <h3 className="font-heading font-bold text-base text-foreground-950">内容说明</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    本站为影视资源整理与内容展示站点，片名、评分与介绍均为演示资料，用于呈现页面功能与信息组织方式。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-3">
            {faqItems.map((item) => {
              const isOpen = openId === item.id;
              return (
                <div
                  key={item.id}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? 'border-primary-300 bg-background-100' : 'border-background-200/70 bg-background-50'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-medium text-sm md:text-base text-foreground-950">{item.q}</span>
                    <span
                      className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 -mt-1">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}